<template>
  <form @submit.stop.prevent class="source-form" :id="contentSource.name" ref="sourceitem" >
    <div v-show="deleting" class="deleting-source-spinner">
      <i class="fa-light fa-circle-notch fa-spin"></i>
    </div>
    <div :class="{ 'deleting-source': deleting }">
      <!-- row 1 start -->
      <div class="row">
        <div class="col-lg-6">
          <custom-input
            v-model="contentSource.name"
            :inputType="'text'"
            :name="`name${contentSource.id}`"
            :label="$t('template.cr-tp-name-label')"
            :placeholder="$t('template.cr-tp-name-label')"
          />
        </div>
        <div class="col-lg-6">
          <custom-input
            v-model="contentSourceType"
            :inputType="'text'"
            :isReadonly="true"
            :name="`type${contentSource.id}`"
            :label="'Type'"
            :placeholder="'Type'"
          />
        </div>
      </div>
      <!-- row 1 end -->

      <!-- If Dummy/Test integration start-->
      <div v-if="contentSource.dummy == true" class="dummy-content">
        <dummyContentUploader :dummyList="dummyList" :contentSource="contentSource" :currentType="currentType">
        </dummyContentUploader>
      </div>
      <!-- If Dummy/Test integration end -->

      <div v-else-if="contentSource.fixedIntegration == true" class="fixed-integration">
        <!-- Kept only for fixed integrations like enetPulse -->
      </div>

      <div v-else>
        <!-- Row 2 start (custom content) -->
        <div class="row custom-content">
          <custom-input
            v-model="contentSource.searchURL"
            class="col-lg-6"
            :inputType="'text'"
            :name="`searchUrl${contentSource.name}`"
            :label="$t('data.searchURL')"
            :placeholder="$t('data.searchURL')"
          />
          <custom-input
            v-model="contentSource.dataURL"
            class="col-lg-6"
            :inputType="'text'"
            :name="`dataUrl${contentSource.name}`"
            :label="'Data URL'"
            :placeholder="'Data URL'"
          />
        </div>
        <!-- Row 2 end (custom content) -->
      </div>
      <div class="actions">
        <button @click="onSaveEdit(contentSource)" :disabled="changesMade" class="btn btn-primary">
          <span v-show="saving"><i class="fa-light fa-circle-notch fa-spin"></i> </span>
          <span v-show="!saving">{{ $t("save") }} </span>
        </button>
        <button @click="onDeleteSource(contentSource)" class="btn btn-secondary">
          {{ $t("delete") }}
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import DummyContentUploader from "@/components/DummyContentUploader";
import CustomInput from "@/components/CustomInput";
import ExampleIdSearch from "@/components/modals/ExampleIdSearch";
export default {
  data() {
    return {
      contentSourceCopy: null,
      dummyListOpened: true,
      dummyList: [],
      changes: false,
      hoverInfo: false,
      saving: false,
      deleting: false,
    };
  },
  props: {
    contentSource: Object,
    currentType: Object,
    formDataIndex: Number,
  },
  computed: {
    contentSourceType() {
      return this.contentSource.fixedIntegration
        ? this.contentSource.enumName + " Connector"
        : this.contentSource.dummy == true
        ? "Test data"
        : this.$t("data.custom");
    },
    changesMade() {
      return JSON.stringify(this.contentSource) == JSON.stringify(this.contentSourceCopy);
    },
  },
  methods: {
    openSearch() {
      this.$modal.show(
        ExampleIdSearch,
        {
          contentSource: this.contentSource,
          selectAsExampleId: (id) => {
            this.$set(
              this.contentSource.fixedIntegration ? this.contentSource.config : this.contentSource,
              "exampleId",
              id,
            );
            this.changes = true;
          },
        },
        { width: 310, height: "auto" },
      );
    },
    onDeleteSource(source){
        this.$store.dispatch("showConfirmation", {
          title: this.$t("delete-modal.delete"),
          description: this.$t("delete-modal.delete-integration-desc") + this.contentSource.name,
          confirmButtonText: this.$t("delete-modal.accept"),
        }).then((res) => {
          this.deleteSource(source)
        })
    },
    deleteSource(contentSource) {
      this.deleting = true;
      this.$store
        .dispatch("deleteSource", contentSource)
        .then(() => {
          // this.$emit("success");
          this.deleting = false;
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
        });
    },

    countUploads(c) {
      this.$emit("count-uploads", c);
    },

    onSaveEdit(contentSource) {
      this.saving = true;
      this.$store
        .dispatch("editSource", contentSource)
        .then(() => {
          // this.success();
          this.makeSourceCopy();
          this.changes = false;
          this.saving = false;
        })
        .catch((error) => {
          this.saving = false;
          this.error = true;
          console.log(error);
        });
    },

    makeSourceCopy() {
      const copy = JSON.stringify(this.contentSource);
      this.contentSourceCopy = JSON.parse(copy);
    },
  },
  created() {
    this.makeSourceCopy();
  },
  components: {
    DummyContentUploader,
    CustomInput,
  },
  watch: {
    contentSource: {
      handler: function(val, oldVal) {
        this.changes = true;
      },
      deep: true,
    },
  },
  mounted(){
    if (this.$store.state.postDemoGuide) {
      const demoPopupPlacement = this.$refs.sourceitem.getBoundingClientRect();
      this.$store.commit("addPositionToDemoGuide", {
        step: 2,
        x: demoPopupPlacement.left,
        y: demoPopupPlacement.y,
        placement: "left"
      });
      this.$store.commit("setDemoGuideCurrentStep", 2);
      this.$store.commit("showDemoGuide", true);
    }
  }
};
</script>

<style lang="less">
.source-form {
  position: relative;
  border-radius: var(--standard-border-radius);
  padding: 20px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
  background-color: var(--background-white);

  .actions button {
    margin-top: 1rem;
    margin-right: 10px;
  }

 
}
</style>
